import design from './ja-JP/design';
import menu from './ja-JP/menu';
import mockup from './ja-JP/mockup';
import pages from './ja-JP/pages';

export default {
  'navBar.lang': '言語',
  ...menu,
  ...pages,
  ...mockup,
  ...design,
};
